// ABOUTME: The right-pointing chevron of disclosure rows; rotated by callers for back and expand
// ABOUTME: Drawn in currentColor — black by default (`text-black`), the foreground in the dark theme

import { cn } from "@shared/lib/utils"

export const ArrowRightIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={cn("text-black", className)}
      width="10"
      height="18"
      viewBox="0 0 10 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.03055 9.53063L1.53055 17.0306C1.46087 17.1003 1.37815 17.1556 1.2871 17.1933C1.19606 17.231 1.09847 17.2504 0.999929 17.2504C0.901383 17.2504 0.803801 17.231 0.712756 17.1933C0.621712 17.1556 0.538986 17.1003 0.469303 17.0306C0.399621 16.9609 0.344345 16.8782 0.306633 16.7872C0.268921 16.6961 0.249512 16.5986 0.249512 16.5C0.249512 16.4015 0.268921 16.3039 0.306633 16.2128C0.344345 16.1218 0.399621 16.0391 0.469303 15.9694L7.43962 9L0.469303 2.03063C0.328573 1.8899 0.249512 1.69903 0.249512 1.50001C0.249512 1.30098 0.328573 1.11011 0.469303 0.96938C0.610034 0.82865 0.800906 0.749588 0.999929 0.749588C1.19895 0.749588 1.38982 0.82865 1.53055 0.96938L9.03055 8.46938C9.10029 8.53903 9.15561 8.62175 9.19335 8.7128C9.23109 8.80385 9.25052 8.90144 9.25052 9C9.25052 9.09857 9.23109 9.19616 9.19335 9.28721C9.15561 9.37826 9.10029 9.46098 9.03055 9.53063Z"
        fill="currentColor"
      />
    </svg>
  )
}
